
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public/profile/artistProfile",
      function () {
        return require("private-next-pages/public/profile/artistProfile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public/profile/artistProfile"])
      });
    }
  